import { Box, Container, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import service from '../../assets/images/service.png';
import service1 from '../../assets/images/service1.png';
import { CheckCircleOutline } from '@mui/icons-material';
import { useInView } from '../../hooks/useInView';

const PRIMARY = '#8c7c0c';

const FEATURES = [
    'Free business listing for home-related services',
    'Increased visibility to potential clients',
    'Direct customer inquiries and bookings',
    'Ability to showcase reviews and ratings',
    'Seamless communication with clients',
    'Opportunity to offer special discounts and promotions',
    'Integration with digital payments for easy transactions',
    'Access to a marketplace for second-hand home-related items',
    'Networking opportunities with property owners and tenants',
    'Personalized business profile to showcase expertise',
    "Sheltergram's marketing support to attract more clients",
];

const Services: FC = () => {
    const { ref, visible } = useInView();

    return (
        <Box component="section" id="services" ref={ref} sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
                    {/* Stacked phone images */}
                    <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <Box
                            className={`sg-reveal ${visible ? 'sg-visible' : ''}`}
                            style={{ transitionDelay: '0.05s' }}
                        >
                            <img
                                src={service}
                                alt="Service provider app"
                                loading="lazy"
                                style={{ height: 460, width: 'auto', objectFit: 'contain', borderRadius: 24, transform: 'rotate(-5deg)', boxShadow: '10px 10px 30px rgba(0,0,0,.18)' }}
                            />
                        </Box>
                        <Box
                            className={`sg-reveal ${visible ? 'sg-visible' : ''}`}
                            style={{ transitionDelay: '0.15s', marginTop: 48 }}
                        >
                            <img
                                src={service1}
                                alt="Service listing app"
                                loading="lazy"
                                style={{ height: 460, width: 'auto', objectFit: 'contain', borderRadius: 24, transform: 'rotate(5deg)', boxShadow: '10px 10px 30px rgba(0,0,0,.18)' }}
                            />
                        </Box>
                    </Grid>

                    {/* Copy */}
                    <Grid item xs={12} md={7}>
                        <Box className={`sg-reveal-right ${visible ? 'sg-visible' : ''}`}>
                            <Typography sx={{ display: 'inline-block', bgcolor: `${PRIMARY}12`, color: PRIMARY, px: 2, py: 0.5, borderRadius: 20, fontSize: 13, fontWeight: 600, mb: 2 }}>
                                For Service Providers
                            </Typography>
                            <Typography component="h2" sx={{ fontSize: { xs: 30, md: 42 }, fontWeight: 800, color: '#111827', lineHeight: 1.2, mb: 2 }}>
                                Offer Your Home Services &amp; Grow Your Business
                            </Typography>
                            <Typography sx={{ fontSize: 15.5, color: '#6b7280', lineHeight: 1.7, mb: 4 }}>
                                Join thousands of plumbers, cleaners, electricians, and other home service providers who are reaching new clients every day on Sheltergram.
                            </Typography>

                            <Grid container spacing={1.5}>
                                {FEATURES.map((f, i) => (
                                    <Grid item xs={12} sm={6} key={f}>
                                        <Box
                                            className={`sg-reveal ${visible ? 'sg-visible' : ''}`}
                                            style={{ transitionDelay: `${i * 0.04}s` }}
                                            sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}
                                        >
                                            <CheckCircleOutline sx={{ color: PRIMARY, fontSize: 18, mt: 0.3, flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: 14, color: '#374151', lineHeight: 1.5 }}>{f}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>

                            <Box sx={{ mt: 4 }}>
                                <a href="/auth?signup=true" className="sg-btn-primary">List Your Business Free</a>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Services;
